import axiosInstance from "../../apiAxios/axiosInstance";



// export const getLeadList = async (payload) => {
//   const response = await axiosInstance.post("/admin/lead-filter", payload);
//   return response.data;
// };

// forAdmin intigrate in admin page 
export const getLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-admin-status-other", payload);
  return response.data;
};
// For Dashboard
export const getAllLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/get-all-lead-list", payload);
  return response.data;
};

//pending lead for admin
export const getadminPendingLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-admin-status-pending", payload);
  return response.data;
};
export const getNewLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-admin-status-new", payload);
  return response.data;
};
export const getConvertedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-admin-status-converted", payload);
  return response.data;
};
export const getLostLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-admin-status-lost", payload);
  return response.data;
};
export const getAssignedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-admin-status-assigned", payload);
  return response.data;
};
export const getUnAssignedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-admin-status-unassigned", payload);
  return response.data;
};
//today for admin api
export const getTodayAllLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/today-all-lead-list", payload);
  return response.data;
};
export const getTodayPendingLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/today-pending-lead-list", payload);
  return response.data;
};
export const getTodayConvertedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/today-converted-lead-list", payload);
  return response.data;
};
export const getTodayLostLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/today-lost-lead-list", payload);
  return response.data;
};
export const getTodayAssignedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/today-assigned-lead-list", payload);
  return response.data;
};
export const getTodayUnAssignedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/today-unassigned-lead-list", payload);
  return response.data;
};


// ... aapke baaki functions (getLeadList, updateLead, etc.)

export const getDeletedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-deleted-list", payload);
  return response.data;
};

export const restoreLead = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-restore", payload);
  return response.data;
};

export const permanentDeleteLead = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-permanent-delete", payload);
  return response.data;
};





// for staff
export const getOtherLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-staff-status-other", payload);
  return response.data;
};

export const getstaffPendingLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-staff-status-pending", payload);
  return response.data;
};
export const AssignedLeadList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-staff-status-assigned", payload);
  return response;
};
export const deleteLead = async (payload) => {
  const res = await axiosInstance.post("/admin/lead-delete", payload);
  return res.data;
};

export const getLeadDetails = async (id) => {
  const response = await axiosInstance.post(
    "/admin/lead-show",
    { id }
  );

  return response.data;
};
export const updateLead = (paylod) =>
  axiosInstance.post("/admin/lead-update", paylod)

export const createLead = (payload) =>
  axiosInstance.post("/admin/lead-store", payload)

export const uploadLeadCSV = (file) => {
  const formData = new FormData();
  formData.append("csv_file", file);
  return axiosInstance
    .post("/admin/lead-csv-upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(res => res.data);
};

export const uploadLeadExcel = (file) => {
  const formData = new FormData();
  formData.append("excel_file", file);
  return axiosInstance
    .post("/admin/lead-excel-upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(res => res.data);
};

export const getLeadCSVTemplate = () =>
  axiosInstance
    .get("/admin/lead-csv-template", {
      responseType: "blob",
    })
    .then(res => res.data);

export const getLeadExcelTemplate = async () => {
  return axiosInstance.get("/admin/lead-excel-template", {
    responseType: "blob",
  });
};

// export const updateLeadStatus = async (payload) => {
//   const response = await axiosInstance.post(
//     "/admin/lead-status-update",
//     payload
//   );

//   return response.data;
// };

export const updateLeadStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/lead-status-update",
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};
export const updateLeadSubStatus = (id, sub_status, remarks) =>
  axiosInstance
    .post("/admin/lead-substatus-update", {
      id,
      sub_status,
      remarks,
    })
    .then((res) => res.data);